// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NlYA","left":"styles_left__1_B1T"};